// removed by extract-text-webpack-plugin
module.exports = {"Tooltip":"Tooltip__Tooltip__iXHVP","Top":"Tooltip__Top__1es5H","Bottom":"Tooltip__Bottom__1cnR0","Active":"Tooltip__Active__3yY51"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Tooltip/Tooltip.css
// module id = 130
// module chunks = 0